/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum SpaceSizeUnit {
    GB = 1,
    TB = 2,
}
